import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addGameReachedZero,
  setResultNumbers,
  setTimerState,
  resetGameTimer,
} from '../../store/gameSlice';
import { useTheme } from '../../utils/ThemeContext';
import classes from './CounterComponent.module.scss';

function CounterComponent() {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const timers = useSelector((state) => state.game.timers);
  const [timeLeft, setTimeLeft] = useState(null);
  const [, setStartTime] = useState(null);
  const timerRef = useRef({});
  const numbersGeneratedRef = useRef(false);

  useEffect(() => {
    const initTimer = () => {
      const savedTimer = timers[theme.themeName];
      if (savedTimer) {
        const elapsedTime = Math.floor(
          (Date.now() - savedTimer.startTime) / 1000,
        );
        const remainingTime = savedTimer.timeLeft - elapsedTime;
        setTimeLeft(remainingTime > 0 ? remainingTime : 0);
        setStartTime(savedTimer.startTime);
      } else {
        const defaultTime = getMinutesForTheme(theme.themeName) * 60;
        setTimeLeft(defaultTime);
        setStartTime(Date.now());
        setTimeout(() => {
          dispatch(
            setTimerState({
              themeName: theme.themeName,
              timeLeft: defaultTime,
              startTime: Date.now(),
            }),
          );
        }, 0);
      }
    };
    initTimer();
  }, [theme, dispatch, timers]);

  useEffect(() => {
    if (timeLeft === null || timeLeft < 0) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 0) {
          if (!numbersGeneratedRef.current) {
            numbersGeneratedRef.current = true;
            dispatch(addGameReachedZero(theme.themeName));
            const randomNumbers = generateRandomResultNumbers(theme.themeName);
            dispatch(
              setResultNumbers({
                themeName: theme.themeName,
                numbers: randomNumbers,
              }),
            );
          }
          const resetTime = getMinutesForTheme(theme.themeName) * 60;
          dispatch(
            resetGameTimer({
              themeName: theme.themeName,
              defaultTime: resetTime,
            }),
          );
          return resetTime;
        }

        const newTime = prevTime - 1;
        timerRef.current[theme.themeName] = newTime;
        return newTime;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft, dispatch, theme.themeName]); // Ensure the dependencies are correct

  useEffect(() => {
    if (timeLeft === getMinutesForTheme(theme.themeName) * 60) {
      numbersGeneratedRef.current = false;
    }
  }, [timeLeft, theme.themeName]);

  const getMinutesForTheme = (themeName) => {
    switch (themeName) {
      case 'pick 3':
        return theme.counterTime;
      case 'lotto 5/90':
        return theme.counterTime;
      case 'lotto 4/48':
        return theme.counterTime;
      case 'Lotto 6/49':
        return theme.counterTime;
      default:
        return 0;
    }
  };

  const generateRandomResultNumbers = (themeName) => {
    let numbers = [];
    switch (themeName) {
      case 'lotto 5/90':
        while (numbers.length < 5) {
          const randomNum = Math.floor(Math.random() * 90) + 1;
          if (!numbers.includes(randomNum)) numbers.push(randomNum);
        }
        break;
      case 'lotto 4/48':
        while (numbers.length < 4) {
          const randomNum = Math.floor(Math.random() * 48) + 1;
          if (!numbers.includes(randomNum)) numbers.push(randomNum);
        }
        break;
      case 'Lotto 6/49':
        while (numbers.length < 6) {
          const randomNum = Math.floor(Math.random() * 49) + 1;
          if (!numbers.includes(randomNum)) numbers.push(randomNum);
        }
        break;
      case 'pick 3':
        for (let i = 0; i < 3; i++) {
          const randomNum = Math.floor(Math.random() * 10);
          numbers.push(randomNum);
        }
        break;
      default:
        break;
    }
    return numbers;
  };

  const minutesRemaining = Math.floor(timeLeft / 60);
  const secondsRemaining = timeLeft % 60;

  return (
    <div>
      <span
        className={classes.counterStyle}
        style={{ color: theme.selectedColor }}
      >
        {minutesRemaining < 10 ? `0${minutesRemaining}` : minutesRemaining}:
        {secondsRemaining < 10 ? `0${secondsRemaining}` : secondsRemaining}
      </span>
    </div>
  );
}

export default CounterComponent;
